import * as React from "react";
import type { SVGProps } from "react";
const SvgPassword01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.529 12h.14M12 12h.14m5.19 0h.14M2.4 15.267V8.733c0-1.178.955-2.133 2.133-2.133h14.934c1.178 0 2.133.955 2.133 2.133v6.534a2.133 2.133 0 0 1-2.133 2.133H4.533A2.133 2.133 0 0 1 2.4 15.267Z"
    />
  </svg>
);
export default SvgPassword01;
